// admin-web calls setInstance before rendering; the removed client-web used it too.
// See docs/shared.md for shared/admin i18next ownership.
const _inst = {
    i18n: null
}
// console.log('Initial i18n inst', _inst.i18n)
const instance = {
    i18n: () => {
        // console.log('get i18n inst', _inst)
        return _inst.i18n
    },
    setInstance: inst => {
        _inst.i18n = inst
    },
}

module.exports = instance
